import { SerializedError } from "@reduxjs/toolkit";

import { INewsletterState } from "components/newsletter-form/state";
import { ISearchFilterState } from "components/search-filter/state";
import { ISearchState } from "components/site-search/state";
import { IToolSearchState } from "components/tool-search/state";

export enum IAPIState {
  idle,
  pending,
  succeeded,
  failed,
}

export interface IErrorPayload {
  error: SerializedError;
}

export interface IStoreState {
  newsletter: INewsletterState;
  search: ISearchState;
  searchFilter: ISearchFilterState;
  toolSearch: IToolSearchState;
}
